import { fromJS } from 'immutable';

import { setStateCurrentType } from '@Constants/StateCurrent';

export const initialState = fromJS({
  name: null
});

export function reducer (state = initialState, action) {
  switch(action.type) {
    case setStateCurrentType: {
      const { stateCurrent } = action;
      return state.merge(fromJS(stateCurrent));
    }
    default: {
      return state;
    }
  }
}
